import { Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import DownloadIcon from '@mui/icons-material/Download';
import AddCircleIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';

const StorageLocationActionMenuReverseWarehouse = ({ selectedButtonName, setSelectedButtonName, handlecallProcess,disableSavebtn }) => {
    const userPermissions = useUserPermissions();
    const [selectedButton, setSelectedButton] = useState(null);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setSelectedButtonName(buttonName);

        handlecallProcess(buttonName);
    };

    return (

        <Grid container display="flex" justifyContent="flex-end" padding={0}>

            {/* Add Button */}
            {/* <Divider orientation="vertical" flexItem sx={{ marginLeft: "10px", marginRight: "10px" }} /> */}
            {(selectedButtonName !== 'addLocation' && selectedButtonName !== 'reverse')  && (
                <>
                    <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                    <Grid item md={0} ml="1px" mr="1px">
                        <Tooltip title="Store FG in Location">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <IconButton onClick={() => handleButtonClick('addLocation')}  >
                                    <ArrowBackIcon style={{ fontSize: "18px", color: selectedButton === 'addLocation' ? "yellow" : "#009688" }} />
                                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>Back</Typography>
                                </IconButton>
                                {/* <span style={{ fontSize: 12 }}>Edit</span> */}
                            </div>
                        </Tooltip>
                    </Grid>
                    {hasPermission(userPermissions, "FG Report", "Print") && (
                    <>
                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                        <Grid item md={0} ml="1px" mr="1px">
                            <Tooltip title="export report data">
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <IconButton onClick={() => handleButtonClick('export')}  >
                                        <DownloadIcon style={{ fontSize: "18px", color: selectedButton === 'export' ? "yellow" : "#009688" }} />
                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Export</Typography>
                                    </IconButton>
                                    {/* <span style={{ fontSize: 12 }}>Edit</span> */}
                                </div>
                            </Tooltip>
                        </Grid>
                    </>)}


                </>
            ) || (<>
              
                {hasPermission(userPermissions, "FG Report", "View") && (
                    <>
                        <Grid item md={0} ml="1px" mr="1px">
                            <Tooltip title="Back to menu">
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <IconButton onClick={() => handleButtonClick('viewReport')}  >
                                        <VisibilityIcon style={{ fontSize: "18px", color: selectedButton === 'viewReport' ? "yellow" : "#009688" }} />
                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>View Report</Typography>
                                    </IconButton>
                                    {/* <span style={{ fontSize: 12 }}>Edit</span> */}
                                </div>
                            </Tooltip>
                        </Grid>
                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                    </>
                )}



                {hasPermission(userPermissions, "FG Report", "Delete") && (
                    <>
                        <Grid item md={0} ml="1px" mr="1px">
                            <Tooltip title="Back to menu">
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <IconButton onClick={() => handleButtonClick('reverse')}  >
                                        <SettingsBackupRestoreIcon style={{ fontSize: "18px", color: selectedButton === 'reverse' ? "yellow" : "#009688" }} />
                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Reverse Storage Location</Typography>
                                    </IconButton>
                                    {/* <span style={{ fontSize: 12 }}>Edit</span> */}
                                </div>
                            </Tooltip>
                        </Grid>
                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                    </>
                )}
            </>)}

            {/* Add Button */}
            {/* <Grid item md={0} ml="1px" mr="1px">
                <Tooltip title="Add new orders">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('printReport')}>
                            <DownloadIcon style={{ fontSize:"18px" ,color: selectedButton === 'printReport' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Export Report</Typography>
                        </IconButton>
                       
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} /> */}
            {/* Add Button */}



        </Grid>



    )
};
export default StorageLocationActionMenuReverseWarehouse;